import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "dark",
  timemode: "UTC",
  isSidebarOpen: false,
  user: null,
  token: null,
  offlineMode: false,
  params: [],
  crewRanks: [],
  crewFlights: [],
  flights: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "dark" ? "light" : "dark";
    },
    setTimeMode: (state) => {
      state.timemode = state.timemode === "UTC" ? "LocalBase" : "UTC";
    },
    setOpenSidebar: (state, action) => {
      state.isSidebarOpen = action.payload;
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.params = action.payload.params;
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      state.offlineMode = false;
    },
    setOfflineMode: (state, action) => {
      state.offlineMode = action.payload;
    },
    setOfflineLogin: (state, action) => {
      state.user        = action.payload.user;
      state.params      = action.payload.params;
      state.token       = null;
      state.offlineMode = true;
    },
    setCrewRanks: (state, action) => {
      state.crewRanks = action.payload.crewRanks;
    },
    setCrewFlights: (state, action) => {
      state.crewFlights = action.payload.crewFlights;
    },
    setFlights: (state, action) => {
      state.flights = action.payload.flights;
    },    
  },
});

export const {
  setMode,
  setTimeMode,
  setOpenSidebar,
  setLogin,
  setLogout,
  setOfflineMode,
  setOfflineLogin,
  setCrewRanks,
  setCrewFlights,
  setFlights,
} = authSlice.actions;
  
export default authSlice.reducer;
